import { Rooftop, Post } from '@libs/models';
import { Pagination, PaginationQuery } from '@libs/dto';

import { api } from '../common.api';

export const rooftopJobseekerApi = api.injectEndpoints({
  endpoints: (build) => ({
    getJobseekerRooftop: build.query<Rooftop, number>({
      query: (id) => `/rooftop/jobseeker/${id}`,
    }),
    getJobseekerRooftopPosts: build.query<Pagination<Post>, { id: number } & PaginationQuery>({
      query: ({ id, page = 1, limit = 10 }) => ({
        url: `/rooftop/jobseeker/${id}/posts`,
        method: 'GET',
        params: { page, limit },
      }),
    }),
  }),
});

export const { 
  useGetJobseekerRooftopQuery,
  useGetJobseekerRooftopPostsQuery,
  useLazyGetJobseekerRooftopPostsQuery 
} = rooftopJobseekerApi;
